// src/utils/formattingUtils.js

export const formatCurrency = (value) => {
    if (isNaN(value)) return '₹0.00';
    const numberFormat = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return numberFormat.format(value);
};

export const getOrdinal = (number) => {
    const j = number % 10;
    const k = number % 100;
    if (j === 1 && k !== 11) return `${number}st`;
    if (j === 2 && k !== 12) return `${number}nd`;
    if (j === 3 && k !== 13) return `${number}rd`;
    return `${number}th`;
};

export const formatNumber = (number) =>
    number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';